import React from "react"
import {Box, colors, Divider, FormControl, FormControlLabel, Radio, RadioGroup, Typography,} from "@material-ui/core"
import {makeStyles} from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1, 0),
  },
  questionText: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  questionDescription: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  optionsContainer: {
    marginTop: theme.spacing(1),
  },
  optionItem: {
    margin: theme.spacing(0.5, 0),
  },
  correctAnswer: {
    backgroundColor: colors.green[100],
    borderLeft: `3px solid ${colors.green[500]}`,
    paddingLeft: theme.spacing(2),
  },
  selectedIncorrect: {
    backgroundColor: colors.red[100],
    borderLeft: `3px solid ${colors.red[500]}`,
    paddingLeft: theme.spacing(2),
  },
  resultChip: {
    marginTop: theme.spacing(2),
  },
}))

const QuestionAnswer = ({
                          questionText,
                          options,
                          disabled,
                          userAnswer,
                        }) => {
  const classes = useStyles()

  return (
    <Box elevation={1} className={classes.root}>
      <Typography variant="body1" className={classes.questionText}>
        {questionText}
      </Typography>
      <Divider/>
      <FormControl component="fieldset" className={classes.optionsContainer}>
        <RadioGroup
          aria-label="question-options"
          name="question-options"
          value={userAnswer}
          style={{display: "flex", flexDirection: "row"}}
        >
          {options.map((option) => {
            let optionClass = ""

            return (
              <FormControlLabel
                key={option.id}
                value={option.id}
                control={<Radio color="primary" disabled={disabled}/>}
                label={
                  <Box display="flex" alignItems="center">
                    {option.label}
                  </Box>
                }
                className={`${classes.optionItem} ${optionClass}`}
                style={{marginRight: 24}} // Add spacing between options
              />
            )
          })}
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

export default QuestionAnswer
